var map = {
	"./cat": "../../node_modules/shelljs/src/cat.js",
	"./cat.js": "../../node_modules/shelljs/src/cat.js",
	"./cd": "../../node_modules/shelljs/src/cd.js",
	"./cd.js": "../../node_modules/shelljs/src/cd.js",
	"./chmod": "../../node_modules/shelljs/src/chmod.js",
	"./chmod.js": "../../node_modules/shelljs/src/chmod.js",
	"./common": "../../node_modules/shelljs/src/common.js",
	"./common.js": "../../node_modules/shelljs/src/common.js",
	"./cp": "../../node_modules/shelljs/src/cp.js",
	"./cp.js": "../../node_modules/shelljs/src/cp.js",
	"./dirs": "../../node_modules/shelljs/src/dirs.js",
	"./dirs.js": "../../node_modules/shelljs/src/dirs.js",
	"./echo": "../../node_modules/shelljs/src/echo.js",
	"./echo.js": "../../node_modules/shelljs/src/echo.js",
	"./error": "../../node_modules/shelljs/src/error.js",
	"./error.js": "../../node_modules/shelljs/src/error.js",
	"./exec": "../../node_modules/shelljs/src/exec.js",
	"./exec-child": "../../node_modules/shelljs/src/exec-child.js",
	"./exec-child.js": "../../node_modules/shelljs/src/exec-child.js",
	"./exec.js": "../../node_modules/shelljs/src/exec.js",
	"./find": "../../node_modules/shelljs/src/find.js",
	"./find.js": "../../node_modules/shelljs/src/find.js",
	"./grep": "../../node_modules/shelljs/src/grep.js",
	"./grep.js": "../../node_modules/shelljs/src/grep.js",
	"./head": "../../node_modules/shelljs/src/head.js",
	"./head.js": "../../node_modules/shelljs/src/head.js",
	"./ln": "../../node_modules/shelljs/src/ln.js",
	"./ln.js": "../../node_modules/shelljs/src/ln.js",
	"./ls": "../../node_modules/shelljs/src/ls.js",
	"./ls.js": "../../node_modules/shelljs/src/ls.js",
	"./mkdir": "../../node_modules/shelljs/src/mkdir.js",
	"./mkdir.js": "../../node_modules/shelljs/src/mkdir.js",
	"./mv": "../../node_modules/shelljs/src/mv.js",
	"./mv.js": "../../node_modules/shelljs/src/mv.js",
	"./popd": "../../node_modules/shelljs/src/popd.js",
	"./popd.js": "../../node_modules/shelljs/src/popd.js",
	"./pushd": "../../node_modules/shelljs/src/pushd.js",
	"./pushd.js": "../../node_modules/shelljs/src/pushd.js",
	"./pwd": "../../node_modules/shelljs/src/pwd.js",
	"./pwd.js": "../../node_modules/shelljs/src/pwd.js",
	"./rm": "../../node_modules/shelljs/src/rm.js",
	"./rm.js": "../../node_modules/shelljs/src/rm.js",
	"./sed": "../../node_modules/shelljs/src/sed.js",
	"./sed.js": "../../node_modules/shelljs/src/sed.js",
	"./set": "../../node_modules/shelljs/src/set.js",
	"./set.js": "../../node_modules/shelljs/src/set.js",
	"./sort": "../../node_modules/shelljs/src/sort.js",
	"./sort.js": "../../node_modules/shelljs/src/sort.js",
	"./tail": "../../node_modules/shelljs/src/tail.js",
	"./tail.js": "../../node_modules/shelljs/src/tail.js",
	"./tempdir": "../../node_modules/shelljs/src/tempdir.js",
	"./tempdir.js": "../../node_modules/shelljs/src/tempdir.js",
	"./test": "../../node_modules/shelljs/src/test.js",
	"./test.js": "../../node_modules/shelljs/src/test.js",
	"./to": "../../node_modules/shelljs/src/to.js",
	"./to.js": "../../node_modules/shelljs/src/to.js",
	"./toEnd": "../../node_modules/shelljs/src/toEnd.js",
	"./toEnd.js": "../../node_modules/shelljs/src/toEnd.js",
	"./touch": "../../node_modules/shelljs/src/touch.js",
	"./touch.js": "../../node_modules/shelljs/src/touch.js",
	"./uniq": "../../node_modules/shelljs/src/uniq.js",
	"./uniq.js": "../../node_modules/shelljs/src/uniq.js",
	"./which": "../../node_modules/shelljs/src/which.js",
	"./which.js": "../../node_modules/shelljs/src/which.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../node_modules/shelljs/src sync recursive ^\\.\\/.*$";